import { SERVICE_URL } from './ServiceURL'

class RetencaoOnline {

	constructor (resource) {
		this.store = resource.$store;
		this.http = resource.$http;
	}

	fetch ({ client, auth }) {
		return new Promise((resolve, reject) => {
			this.http.get(`${SERVICE_URL}v1/contato/campanha/retencao-online?client=${client}&auth=${auth}`, {
				headers: {
					'x-access-token': this.store.state.user.token || ''
				}
			})
				.then(response => response.json())
				.then(refuses => resolve(refuses))
				.catch(err => {
					reject(err.body.message || err.message);
				})
		});
	}

	save({ client, auth, tabulacao }){
		return new Promise((resolve, reject) => {
			this.http.post(`${SERVICE_URL}v1/contato/campanha/retencao-online?client=${client}&auth=${auth}`, tabulacao, {
				headers: {
					'x-access-token': this.store.state.user.token || ''
				}
			})
				.then(response => response.json())
				.then(refuses => resolve(refuses))
				.catch(err => {
					reject(err.body.message || err.message);
				})
		});
	}
}
export default RetencaoOnline;


// WEBPACK FOOTER //
// ./src/service/RetencaoOnline.js